import { SandhillsSlickSlider, Panel } from '@Components/Shared/SandhillsSlickSlider';

const FeaturedEvents = (props) => {

    return (
        
        <div class="featured-events">
            <div class="container">
                <div class="featured-section-title">
                    <h2>{props.Title}</h2>
                </div>
            </div>
            <div class="featured-events-container">
                <SandhillsSlickSlider
                    {...props}
                    settings={{

                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                        adaptiveHeight: true,
                        autoplay: true,
                        infinite: true,
                        autoplaySpeed: 5000,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    dots: true,
                                    autoplay: true,
                                    infinite: true,
                                    autoplaySpeed: 5000,
                                    arrows: false
                                }
                            }
                        ]
                    }}
                >
                    {props.Cards.map((event) =>
                        <Panel
                            key={`slider-${event.Id}`}
                            PanelType={props.ChildComponent}
                            PanelClass={props.PanelClass}
                            OuterDivClass={props.OuterDivClass}
                            InnerDivClass={"featured-event-div" }
                            {...event}
                        />)}
                </SandhillsSlickSlider>
            </div>
        </div>
    );
}

export default FeaturedEvents;